export const PricingForm = (inputs) => {
  let errors = {};

  const isInteger = (value) => /^\d+(\.\d{1,2})?$/.test(value);

  const adminPrice = parseFloat(inputs.admin_price); // dynamic price from masterdata or inputs
  const vendorPrice = parseFloat(inputs.price);
  const thresholdPercent = 10;

  const isVendorPriceValid = (admin, vendor, percent) => {
    const threshold = admin * (percent / 100);
    const min = admin - threshold;
    const max = admin + threshold;
    return vendor >= min && vendor <= max;
  };

  // ---- Price validation ----
  if (!inputs.price) {
    errors.price = 'Enter Price';
  } else if (!isInteger(inputs.price)) {
    errors.price = 'Price must be a valid number';
  } else if (adminPrice && !isVendorPriceValid(adminPrice, vendorPrice, thresholdPercent)) {
    errors.price = `Venddddor price must be between ${(adminPrice * 0.9).toFixed(2)} and ${(adminPrice * 1.1).toFixed(2)}`;
  }

  // ---- Special price validation ----
  if (!inputs.special_price) {
    errors.special_price = 'Enter MRP';
  } else if (!isInteger(inputs.special_price)) {
    errors.special_price = 'MRP must be a valid number';
  }



  return errors;
};

export const SpecificationForm = (inputs) => {
  let errors = {};

  if (!inputs.attribute_name) {
    errors.attribute_name = 'Enter Attribute Name';
  }

  if (!inputs.attribute_description) {
    errors.attribute_description = 'Enter Attribute Description';
  }


  return errors;
};
export const pagesectionform = (inputs) => {
  let errors = {};

  if (!inputs.section_name?.trim() || inputs.section_name == '') {
    errors.section_name = "Enter Section Name";
  }

  // if (!inputs.type) {
  //   errors.type = "Select Component Type";
  // }

  return errors;
};

export const pagesectionimgform = (inputs) => {
  let errors = {};

  if (!inputs.title?.trim()) {
    errors.title = "Enter Title";
  }

  if (!inputs.mobile && !inputs.desktop) {
    errors.image = "Upload at least one image";
  }

  return errors;
};
export const storefrontpages = (inputs) => {
  let errors = {};

  if (!inputs.page_name?.trim()) {
    errors.page_name = "Enter Name";
  }

  if (!inputs.page_url?.trim()) {
    errors.page_url = "Enter Url";
  }

  return errors;
};
export const projectUpdates = (inputs) => {
  let errors = {};

  if (!inputs.video_url) {
    errors.video_url = 'Enter Video Url';
  }


  return errors;
};
export const AmenitesForm = (inputs) => {
  let errors = {};

  if (!inputs.amenitie_type) {
    errors.amenitie_type = 'Select Amenitie type';
  }

  if (!inputs.title) {
    errors.title = 'Enter Title';
  }


  return errors;
};
export const purchasereturnForm = (inputs) => {
  let errors = {};


  if (!inputs.supplierid) {
    errors.supplierid = 'Select supplier';
  }




  return errors;
};
export const projectContact = (inputs) => {
  let errors = {};


  if (!inputs.role) {
    errors.role = 'Enter Role';
  }

  if (!inputs.name) {
    errors.name = 'Enter Name';
  }

  if (!inputs.mobile) {
    errors.mobile = 'Enter Mobile';
  }




  return errors;
};
export const projectCharges = (inputs) => {
  let errors = {};


  if (!inputs.name) {
    errors.name = 'Enter Name';
  }

  if (!inputs.charge_type) {
    errors.charge_type = 'Select Type';
  }

  if (!inputs.amount) {
    errors.amount = 'Enter amount';
  }




  return errors;
};
export const ProjectForm = (inputs) => {
  let errors = {};
  if (!inputs.property_type) {
    errors.property_type = 'Select Property Type';
  }
  if (!inputs.project_name) {
    errors.project_name = 'Enter Name';
  }
  if (!inputs.state_id) {
    errors.state_id = 'Select Sate';
  }
  if (!inputs.city_id) {
    errors.city_id = 'Select City';
  }
  // if (!inputs.area_id) {
  //   errors.area_id = 'Select Area';
  // }
  // if (!inputs.unit_size) {
  //   errors.unit_size = 'Enter Unit Size';
  // }
  // if (!inputs.construction_progress) {
  //   errors.construction_progress = 'Select Status';
  // }
  // if (!inputs.rera) {
  //   errors.rera = 'Enter Rera';
  // }


  // if (!inputs.url) {
  //   errors.url = 'Enter url';
  // }
  // if (!inputs.small_desc) {
  //   errors.small_desc = 'Enter Small Description';
  // }


  return errors;
};
export const LedgerForm = (inputs) => {
  let errors = {};

  if (inputs.name === '') {
    errors.name = 'Name is required';
  }

  return errors;
}
export const PaymentInForm = (inputs) => {
  let errors = {};

  if (inputs.ledgername === '') {
    errors.ledgername = 'ledgername is required';
  }
  if (inputs.vouchertype === '') {
    errors.vouchertype = 'vouchertype is required';
  }
  if (inputs.vouchernumber === '') {
    errors.vouchernumber = 'vouchernumber is required';
  }
  if (inputs.paymentamt === '') {
    errors.paymentamt = 'paymentamt is required';
  }
  if (inputs.paymentmode === '') {
    errors.paymentmode = 'paymentmode is required';
  }
  if (inputs.paymentdate === '') {
    errors.paymentdate = 'paymentdate is required';
  }
  if (inputs.referenceno === '') {
    errors.referenceno = 'referenceno is required';
  }

  return errors;
}
export const PaymentOutForm = (inputs) => {
  let errors = {};

  if (inputs.ledgername === '') {
    errors.ledgername = 'ledgername is required';
  }
  if (inputs.vouchertype === '') {
    errors.vouchertype = 'vouchertype is required';
  }
  if (inputs.vouchernumber === '') {
    errors.vouchernumber = 'vouchernumber is required';
  }
  if (inputs.paymentamt === '') {
    errors.paymentamt = 'paymentamt is required';
  }
  if (inputs.paymentmode === '') {
    errors.paymentmode = 'paymentmode is required';
  }
  if (inputs.paymentdate === '') {
    errors.paymentdate = 'paymentdate is required';
  }
  if (inputs.referenceno === '') {
    errors.referenceno = 'referenceno is required';
  }


  return errors;
}
export const AssetForm = (inputs) => {
  let errors = {};

  if (inputs.name === '') {
    errors.name = 'Name is required';
  }
  if (inputs.parentcategory==="") {
    errors.parentcategory = 'Asset Category Required is required';
  }


  return errors;
}

export const AssetCategoryForm = (inputs) => {
  let errors = {};

  // if (inputs.name === '') {
  //   errors.name = 'Name is required';
  // }
  // if (inputs.parentcategory === '') {
  //   errors.parentcategory = 'Asset Category Required is required';
  // }


  return errors;
}
export const AssetInventoryForm = (inputs) => {
  let errors = {};

  if (inputs.assetname === '') {
    errors.assetname = 'Assetname is required';
  }
  if (inputs.serialno === '') {
    errors.serialno = 'Serialno is required';
  }
  if (inputs.cost === '') {
    errors.cost = 'cost is required';
  }
  if (inputs.quantity === '') {
    errors.quantity = 'quantity is required';
  }

  return errors;
}
export const StatusForm = (inputs) => {
  let errors = {};

  if (inputs.action === '') {
    errors.action = 'Status is required';
  }
  if (inputs.userid === '') {
    errors.userid = 'Userid is required';
  }
  if (inputs.note === '') {
    errors.note = 'Note is required';
  }

  return errors;
}

export const loanEntryForm = (inputs) => {
  let errors = {};
  if (!inputs.loan_amount) {
    errors.loan_amount = 'Enter Loan Amount';
  }
  if (!inputs.interest_rate) {
    errors.interest_rate = 'Enter Interest Rate';
  }
  if (!inputs.installments) {
    errors.installments = 'Enter Interest Rate';
  }

  return errors;
};
export const salarydetails = (inputs) => {
  let errors = {};
  if (!inputs.component_id) {
    errors.component_id = 'Select Component Id';
  }

  if (!inputs.amount) {
    errors.amount = 'Enter Amount';
  }
  return errors;
};
export const projectUnitForm = (inputs) => {
  let errors = {};
  if (!inputs.project_structure_id) {
    errors.project_structure_id = 'Select Project Structure ';
  }
  if (!inputs.unit_plan_id) {
    errors.unit_plan_id = 'Select  Unit Plan';
  }
  // if (!inputs.current_status) {
  //   errors.current_status = 'Select status ';
  // }
  // if (!inputs.owner_type) {
  //   errors.owner_type = 'Select owner ';
  // }

  // if (!inputs.unit_no) {
  //   errors.unit_no = 'Enter Unit No';
  // }
  return errors;
};
export const realesteCustomerForm = (inputs) => {
  let errors = {};
  if (!inputs.typeofbooking) {
    errors.typeofbooking = 'Select type of booking ';
  }
  return errors;
};
export const customerinvoiceaddressform = (inputs) => {
  let errors = {};


  if (!inputs.first_name) {
    errors.first_name = 'Name is required';
  }

  return errors;
};
export const purchaseinventoryEntryForm = (inputs) => {
  let errors = {};




  return errors;
};


export const StaffDetailform = (inputs) => {
  let errors = {};
  if (!inputs.employment_type) {
    errors.employment_type = 'Select Type';
  }
  if (!inputs.department_id) {
    errors.department_id = 'Select Department';
  }
  if (!inputs.designation_id) {
    errors.designation_id = 'Select Designation';
  }
  if (!inputs.location_id) {
    errors.location_id = 'Select location ';
  }
  if (!inputs.Supervisor) {
    errors.Supervisor = 'Enter Supervisor';
  }
  if (!inputs.firstname) {
    errors.firstname = 'Enter Firstname';
  }
  if (!inputs.lastname) {
    errors.lastname = 'Enter Lastname';
  }
  if (!inputs.ledger_name) {
    errors.ledger_name = 'Enter ledger_name';
  }
  if (!inputs.ctc) {
    errors.ctc = 'Enter Ctc';
  }
  if (!inputs.email) {
    errors.email = 'Enter Email';
  }
  if (!inputs.phone) {
    errors.phone = 'Enter Phone';
  }


  return errors;
};

export const purchaseEntryForm = (inputs) => {
  let errors = {};

  // if (!inputs.warehouse_id) {
  //   errors.warehouse_id = 'Select Warehouse';
  // }
  // if (!inputs.supplierid) {
  //   errors.supplierid = 'Select supplier';
  // }
  // if (!inputs.payment_methodid) {
  //   errors.payment_methodid = 'Select Payment Method';
  // }
  if (!inputs.PO) {
    errors.PO = 'Enter PO';
  }
  if (!inputs.AMOUNT) {
    errors.AMOUNT = 'Enter AMOUNT';
  }
  if (!inputs.Tax) {
    errors.Tax = 'Enter Tax';
  }
  if (!inputs.Discount) {
    errors.Discount = 'Enter Discount';
  }
  if (!inputs.GrossAmount) {
    errors.GrossAmount = 'Enter GrossAmount';
  }
  if (!inputs.invoice_no) {
    errors.invoice_no = 'Enter Invoice No';
  }
  // if (!inputs.gstn) {
  //   errors.gstn = 'Enter Tax Number';
  // }
  if (!inputs.TransportCharges) {
    errors.TransportCharges = 'Enter Transport Charges';
  }
  if (!inputs.TransportDetails) {
    errors.TransportDetails = 'Enter Transport Details';
  }
  // if (!inputs.ReceiverName) {
  //   errors.ReceiverName = 'Enter ReceiverName';
  // }


  return errors;
};



export const ProductForm = (inputs) => {
  let errors = {};

  if (!inputs.title) {
    errors.title = 'Enter Product Title';
  }

  if (!inputs.categoryid) {
    errors.categoryid = 'Select Category';
  }
  if (!inputs.brandid) {
    errors.brandid = 'Select Brand';
  }

  return errors;
};
export const stockform = (inputs) => {
  let errors = {};


  if (!inputs.bill_date) {
    errors.bill_date = 'Select Bill Date';
  }
  if (!inputs.from_countryid) {
    errors.from_countryid = 'Select From country';
  }
  if (!inputs.to_countryid) {
    errors.to_countryid = 'Select To country';
  }
  if (!inputs.transfer_through) {
    errors.transfer_through = 'Select Transfer Through';
  }
  if (!inputs.logistic_team) {
    errors.logistic_team = 'Select Logistic Team';
  }
  if (!inputs.expected_delivery) {
    errors.expected_delivery = 'Select Expected Delivery';
  }

  return errors;
};
export const stockreciverform = (inputs) => {
  let errors = {};


  if (!inputs.transfer_refno) {
    errors.transfer_refno = 'Enter Transfer Refno';
  }
  if (!inputs.from_countryid) {
    errors.from_countryid = 'Select From country';
  }
  return errors;
};


export const CoupanForm = (inputs) => {
  let errors = {};

  if (!inputs.coupancode) {
    errors.coupancode = 'Enter Coupancode';
  }
  // if (!inputs.brand) {
  //   errors.brand = 'Enter brand';
  // }

  // if (!inputs.toatlcoupan) {
  //   errors.toatlcoupan = 'Enter No of Coupons';
  // }
  if (!inputs.minorderamt) {
    errors.minorderamt = 'Enter Minimum Order Amount';
  }
  if (!inputs.Redeem) {
    errors.Redeem = 'Enter Redeem/Use';
  }
  if (!inputs.Amount) {
    errors.Amount = 'Enter Amount';
  }
  if (!inputs.period) {
    errors.period = 'Enter Coupon Period';
  }
  if (!inputs.channel) {
    errors.channel = 'Select Channel';
  }
  if (!inputs.deuartion_type) {
    errors.deuartion_type = 'Select Dedution Type';
  }
  if (!inputs.coupantype) {
    errors.coupantype = 'Select Coupan type';
  }

  return errors;
};
export const projectSchudle = (inputs) => {
  let errors = {};

  if (!inputs.schedule_name) {
    errors.schedule_name = 'Select Schedule';
  }

  if (!inputs.display_order) {
    errors.display_order = 'Enter Orer';
  }
  // if (!inputs.planned_budget) {
  //   errors.planned_budget = 'Enter Planned Budget';
  // }
  // if (!inputs.actual_spend) {
  //   errors.actual_spend = 'Enter Actual Spend';
  // }
  // if (!inputs.percent_complete) {
  //   errors.percent_complete = 'Enter % complete';
  // }


  return errors;
};
export const ProjectStructureFORM = (inputs) => {
  let errors = {};


  if (!inputs.name) {
    errors.name = 'Enter Name';
  }



  return errors;
};
export const projectUnitplan = (inputs) => {
  let errors = {};

  if (!inputs.unitplan_name) {
    errors.unitplan_name = 'Enter Unitplan Name';
  }
  if (!inputs.unit_bhk) {
    errors.unit_bhk = 'Select Unit BHK';
  }
  if (!inputs.unit_facing) {
    errors.unit_facing = 'Select Unit Facing';
  }
  if (!inputs.unit_area) {
    errors.unit_area = 'Enter Unit Area';
  }
  return errors;
};
export const projectDocs = (inputs) => {
  let errors = {};


  if (!inputs.document_name) {
    errors.document_name = 'Select Name';
  }
  if (!inputs.document_category) {
    errors.document_category = 'Select Category';
  }
  if (!inputs.document_status) {
    errors.document_status = 'Select document Status';
  }


  return errors;
};
export const customeraddressform = (inputs) => {
  let errors = {};


  if (!inputs.city_id) {
    errors.city_id = 'Select City';
  }
  if (!inputs.state_id) {
    errors.state_id = 'Select State';
  }
  if (!inputs.building_name) {
    errors.building_name = 'Building/Flat No is required';
  }
  if (!inputs.mobile) {
    errors.mobile = 'Mobile is required';
  }
  if (!inputs.address) {
    errors.address = 'Address is required';
  }
  // if (!inputs.name) {
  //   errors.name = 'Name is required';
  // }

  return errors;
};
export const vendorcountryform = (inputs) => {
  let errors = {};

  if (!inputs.city_id) {
    errors.city_id = 'Select City';
  }
  if (!inputs.state_id) {
    errors.state_id = 'Select State';
  }
  if (!inputs.countryid) {
    errors.countryid = 'Select Country';
  }

  return errors;
};

export const VendorCommissionform = (inputs) => {
  let errors = {};

  if (!inputs.category_id) {
    errors.category_id = 'Select Category';
  }
  if (!inputs.commission) {
    errors.commission = 'Select Commission';
  }

  return errors;
};

export const customerDetailform = (inputs) => {
  let errors = {};

  // if (!inputs.gender) {
  //   errors.gender = 'Select Gender';
  // }
  // if (!inputs.nationality) {
  //   errors.nationality = 'Select Nationality';
  // }
  if (!inputs.firstname) {
    errors.firstname = 'Firstname is required';
  }
  if (!inputs.lastname) {
    errors.lastname = 'lastname is required';
  }
  if (!inputs.email) {
    errors.email = 'Email is required';
  }
  if (!inputs.phone) {
    errors.phone = 'Phone is required';
  }


  return errors;
};

export const customerCommentform = (inputs) => {
  let errors = {};

  // if (!inputs.gender) {
  //   errors.gender = 'Select Gender';
  // }
  // if (!inputs.nationality) {
  //   errors.nationality = 'Select Nationality';
  // }
  if (!inputs.comment) {
    errors.comment = 'comment is required';
  }
 


  return errors;
};


export const OrderForm = (inputs) => {
  let errors = {};



  if (!inputs.countryid) {
    errors.countryid = "Country is required";
  }
  if (!inputs.contact) {
    errors.contact = "Number is required";
  }
  //  else if (!/^\d{6}$/.test(inputs.contact)) {
  //   errors.contact = "Contact number must be exactly  digits";
  // }
  if (!inputs.customer_name) {
    errors.customer_name = "Customer Name is required";
  }
  // if (!inputs.address) {
  //   errors.address = "address is required";
  // }

  if (!inputs.order_from) {
    errors.order_from = 'Select Orderform';
  }
  if (!inputs.payment_methodid) {
    errors.payment_methodid = 'Select Payment Method';
  }

  if (!inputs.emirate) {
    errors.emirate = 'Select Emirate';
  }
  // if (!inputs.building) {
  //   errors.building = 'Building/Flat No is required';
  // }
  if (!inputs.nationality) {
    errors.nationality = 'Select Nationality';
  }
  if (!inputs.gender) {
    errors.gender = 'Select Gender';
  }
  return errors;
};
export const webfeedForm = (inputs) => {
  let errors = {};



  if (!inputs.countryid) {
    errors.countryid = "Country is required";
  }
  if (!inputs.contact) {
    errors.contact = "Number is required";
  }
  //  else if (!/^\d{6}$/.test(inputs.contact)) {
  //   errors.contact = "Contact number must be exactly  digits";
  // }
  if (!inputs.customer_name) {
    errors.customer_name = "Customer Name is required";
  }
  // if (!inputs.address) {
  //   errors.address = "address is required";
  // }

  if (!inputs.order_from) {
    errors.order_from = 'Select Orderform';
  }

  if (!inputs.emirate) {
    errors.emirate = 'Select Emirate';
  }
  // if (!inputs.building) {
  //   errors.building = 'Building/Flat No is required';
  // }
  if (!inputs.nationality) {
    errors.nationality = 'Select Nationality';
  }
  // if (!inputs.gender) {
  //   errors.gender = 'Select Gender';
  // }
  return errors;
};
export const OrderCommentForm = (inputs) => {
  let errors = {};
  // if (!inputs.notes) {
  //   errors.notes = "Comment is required";
  // }
  if (!inputs.Message) {
    errors.Message = 'Select Message';
  }
  if (!inputs.assign_to) {
    errors.assign_to = 'Select User';
  }

  return errors;
};
export const webfeedCommentForm = (inputs) => {
  let errors = {};
  // if (!inputs.notes) {
  //   errors.notes = "Comment is required";
  // }
  if (!inputs.Message) {
    errors.Message = 'Select Message';
  }
  if (!inputs.callstatus) {
    errors.callstatus = 'Select callstatus';
  }

  return errors;
};
export const Orderdriverassignform = (inputs) => {
  let errors = {};

  if (!inputs.Drivername) {
    errors.Drivername = 'Select Driver';
  }

  if (inputs.amount === '') {
    errors.amount = 'Amount is required';
  }
  if (inputs.shipments === '') {
    errors.shipments = 'Shipments is required';
  }

  return errors;
};


export const UserForm = (inputs) => {
  let errors = {};

  if (inputs.firstname === '') {
    errors.firstname = 'First Name is required';
  }

  if (!inputs.phone) {
    errors.phone = 'Phone is required';
  }

  if (!inputs.email) {
    errors.email = 'Email address is required';
  }

  if (!inputs.userrname) {
    errors.userrname = "Username is required";
  }

  if (!inputs.password) {
    errors.password = 'Password is required';
  }

  if (!inputs.groups) {
    errors.groups = 'Roles is required';
  }


  return errors;
}

export const CustomerForm = (inputs) => {
  let errors = {};

  if (inputs.firstname === '') {
    errors.firstname = 'First Name is required';
  }

  if (!inputs.lastname) {
    errors.lastname = 'Last Name is required';
  }

  if (!inputs.phone) {
    errors.phone = 'Phone is required';
  }

  if (!inputs.email) {
    errors.email = 'Email address is required';
  }
  return errors;
}

export const MenuForm = (inputs) => {
  let errors = {};

  if (inputs.name === '') {
    errors.name = 'Name is required';
  }
  if (inputs.position === '') {
    errors.position = 'Position is required';
  }
  if (inputs.url_path === '') {
    errors.url_path = 'Url is required';
  }

  return errors;
}

export const CountryForm = (inputs) => {
  let errors = {};

  if (inputs.name === '') {
    errors.name = 'Name is required';
  }

  if (inputs.currency === '') {
    errors.currency = 'Currency is required';
  }

  if (inputs.currency_value === '') {
    errors.currency_value = 'Currency value is required';
  }
  if (inputs.currency_value === '') {
    errors.currency_value = 'Currency value is required';
  }

  if (inputs.vat === '') {
    errors.vat = 'Vat is required';
  }

  return errors;
}

export const SupplierForm = (inputs) => {
  let errors = {};
  if (!inputs.country_id) {
    errors.country_id = 'Select Country';
  }
  if (inputs.company_name === '') {
    errors.company_name = 'Comapny Name is required';
  }
  if (inputs.supplier_name === '') {
    errors.supplier_name = 'Supplier Name is required';
  }
  if (inputs.primary_contact === '') {
    errors.primary_contact = 'Primary Contact is required';
  }
  if (inputs.emailid === '') {
    errors.emailid = 'Email is required';
  }
  return errors;
}

export const GroupForm = (inputs) => {
  let errors = {};

  if (inputs.name === '') {
    errors.name = 'Name is required';
  }

  return errors;
}

export const CommentForm = (inputs) => {
  let errors = {};

  if (inputs.comment === '') {
    errors.comment = 'Comments is required';
  }

  return errors;
}

export const VendorForm = (inputs) => {
  let errors = {};

  if (inputs.business_name === '') {
    errors.business_name = 'Bussiness Name is required';
  }
  if (inputs.contact_phone === '') {
    errors.contact_phone = 'Contact Number is required';
  }
  if (inputs.vatid === '') {
    errors.vatid = 'VAT ID is required';
  }
  if (inputs.emaiid === '') {
    errors.emaiid = 'Email Address is required';
  }
  if (inputs.pan === '') {
    errors.pan = 'Pan card is required';
  }
  if (inputs.contact_person === '') {
    errors.contact_person = 'Contact Person is required';
  }
  if (inputs.business_address === '') {
    errors.business_address = 'Bussiness Address is required';
  }
  if (inputs.bank_details === '') {
    errors.bank_details = 'Bank Details is required';
  }

  return errors;
}

export const EntityForm = (inputs) => {
  let errors = {};

  if (inputs.business_name === '') {
    errors.business_name = 'Bussiness Name is required';
  }
  return errors;
}

export const AgentForm = (inputs) => {
  let errors = {};

  if (inputs.business_name === '') {
    errors.business_name = 'Bussiness Name is required';
  }
  if (!inputs.contact_phone) {
    errors.contact_phone = "Contact Number is required";
  } else if (!/^[6-9]\d{9}$/.test(inputs.contact_phone)) {
    errors.contact_phone = "Enter a valid 10-digit mobile number";
  }
  if (inputs.ledger_name === '') {
    errors.vatid = 'Ledger name is required';
  }
  if (!inputs.emaiid) {
    errors.emaiid = "Email Address is required";
  } else if (
    !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(inputs.emaiid)
  ) {
    errors.emaiid = "Enter a valid email address";
  }
  if (inputs.contact_person === '') {
    errors.contact_person = 'Contact Person is required';
  }
  // if (inputs.vatid === '') {
  //   errors.vatid = 'VAT ID is required';
  // }
  // if (inputs.pan === '') {
  //   errors.pan = 'Pan card is required';
  // }
  if (inputs.cluster === '') {
    errors.cluster = 'Cluster name is required';
  }
  // if (inputs.rera_name === '') {
  //   errors.rera_name = 'RERA Name is required';
  // }
  // if (inputs.rera_number === '') {
  //   errors.rera_number = 'RERA Number is required';
  // }
  if (inputs.rera_certificate_expiry === '') {
    errors.rera_certificate_expiry = 'RERA Certificate Expiry Date is required';
  }

  // if (!inputs.bank_accountname) {
  //   errors.bank_accountname = 'Account Holder Name is required';
  // }

  // if (!inputs.bank_name) {
  //   errors.bank_name = 'Bank Name is required';
  // }

  // if (!inputs.bank_acc_no) {
  //   errors.bank_acc_no = 'Account Number is required';
  // }
  // else if (!/^\d{9,18}$/.test(inputs.bank_acc_no)) {
  //   errors.bank_acc_no = 'Account Number must be 9–18 digits';
  // }

  // if (!inputs.bank_ifsc_code) {
  //   errors.bank_ifsc_code = 'IFSC Code is required';
  // }
  // else if (!/^[A-Z]{4}0[A-Z0-9]{6}$/.test(inputs.bank_ifsc_code)) {
  //   errors.bank_ifsc_code = 'Invalid IFSC Code';
  // }

  return errors;
}

export const MasterForm = (inputs) => {
  let errors = {};

  if (inputs.name === '') {
    errors.name = 'Collection is required';
  }
  if (inputs.list_type === '') {
    errors.list_type = 'Type is required';
  }

  return errors;
}
export const SearchForm = (inputs) => {
  let errors = {};

  if (inputs.searchkeyword === '') {
    errors.searchkeyword = 'Search keyword is required';
  }
  if (inputs.url === '') {
    errors.url = 'Redirect url is required';
  }

  return errors;
}

export const PostCategoryForm = (inputs) => {
  let errors = {};

  if (inputs.name === '') {
    errors.name = 'Name is required';
  }
  if (inputs.arabic_name === '') {
    errors.arabic_name = 'Arabic Name is required';
  }

  return errors;
}

export const PostForm = (inputs) => {
  let errors = {};

  if (inputs.name === '') {
    errors.name = 'Page Title is required';
  }

  if (inputs.posts_type === '') {
    errors.posts_type = 'Page Type is required';
  }

  // if (inputs.post_status === '') {
  //   errors.post_status = 'Status is required';
  // }

  if (inputs.categories === '') {
    errors.categories = 'Category is required';
  }

  if (inputs.featured === '') {
    errors.featured = 'Featured is required';
  }

  return errors;
}

export const BrandForm = (inputs) => {
  let errors = {};

  if (inputs.name === '') {
    errors.name = 'Name is required';
  }

  return errors;
}

export const AttributeForm = (inputs) => {
  let errors = {};

  if (inputs.name === '') {
    errors.name = 'Name is required';
  }
  if (inputs.arabic_name === '') {
    errors.arabic_name = 'Arabic Name is required';
  }

  return errors;
}

export const CategoryForm = (inputs) => {
  let errors = {};
  if (inputs.categorytype === '') {
    errors.categorytype = 'Category type is required';
  }

  if (inputs.name === '') {
    errors.name = 'Name is required';
  }


  return errors;
}

export const VarientForm = (inputs) => {
  let errors = {};

  if (inputs.name === '') {
    errors.name = 'Variant Name is required';
  }
  if (inputs.category === '') {
    errors.category = 'Category is required';
  }
  if (inputs.brand === '') {
    errors.brand = 'Brand is required';
  }

  return errors;
}

export const ComplainForm = (inputs) => {
  let errors = {};
  const isInteger = (value) => /^\d+(\.\d{1,2})?$/.test(value);



  if (inputs.project_id === '') {
    errors.project_id = 'Project is required';
  }
  // if (inputs.unit_no === '') {
  //   errors.unit_no = 'Unit is required';
  // }
  if (inputs.category === '') {
    errors.category = 'Category is required';
  }


  if (inputs.complain_source === '') {
    errors.complain_source = 'Source is required';
  }
  if (inputs.title === '') {
    errors.title = 'Title is required';
  }

  if (inputs.rstatus === '') {
    errors.rstatus = 'Status is required';
  }
  if (inputs.owner === '') {
    errors.owner = 'Assign to is required';
  }
 


  if (inputs.priorty === '') {
    errors.priorty = 'Severity is required';
  }

  return errors;
}
export const LeaveForm = (inputs) => {
  let errors = {};

  if (inputs.reason === '') {
    errors.reason = 'Reason is required';
  }
  if (inputs.leavetype === '') {
    errors.leavetype = 'Leave type is required';
  }
  if (inputs.totaldays === '') {
    errors.totaldays = 'Totaldays is required';
  }

  return errors;
}
export const DepartmentForm = (inputs) => {
  let errors = {};

  if (inputs.name === '') {
    errors.name = 'Type is required';
  }


  return errors;
}
export const DesignationForm = (inputs) => {
  let errors = {};

  if (inputs.name === '') {
    errors.name = 'Type is required';
  }


  return errors;
}
export const ExitRequestForm = (inputs) => {
  let errors = {};
  if (inputs.reason === '') {
    errors.reason = 'Type is requied';
  }
  if (inputs.reasonlwd === '') {
    errors.reasonlwd = 'Type is requied';
  }

  return errors;

}
export const SlaForm = (inputs) => {
  let errors = {};

  if (inputs.category === '') {
    errors.category = 'Category is required';
  }

  if (inputs.priority === '') {
    errors.priority = 'Severity is required';
  }

  if (inputs.duration === '') {
    errors.duration = 'Duration is required';
  }

  return errors;
}

export const SectionForm = (inputs) => {
  let errors = {};

  if (inputs.name === '') {
    errors.name = 'Name is required';
  }

  if (inputs.country === '') {
    errors.country = 'Country is required';
  }

  if (inputs.category === '') {
    errors.category = 'Category is required';
  }

  return errors;
}

export const BannerForm = (inputs) => {
  let errors = {};

  if (inputs.type === '') {
    errors.type = 'Type is required';
  }

  if (inputs.type_id === '') {
    errors.type_id = 'Type Id is required';
  }


  return errors;
}

export const AuditForm = (inputs) => {
  let errors = {};

  if (inputs.checklist_name === '') {
    errors.checklist_name = 'Checklist name is required';
  }

  if (inputs.checklist_category_id === 0) {
    errors.checklist_category_id = 'Checklist category is required';
  }


  return errors;
}

export const AuditsForm = (inputs) => {
  let errors = {};

  if (inputs.checklist_id === 0) {
    errors.checklist_id = 'Checklist is required';
  }


  return errors;
}



export const AuditScheduleForm = (inputs) => {
  let errors = {};

  if (inputs.group === '') {
    errors.group = 'Group name is required';
  }

  if (inputs.users === '') {
    errors.users = 'Users is required';
  }

  if (inputs.schedule_date === '') {
    errors.schedule_date = 'Schedule date is required';
  }

  if (inputs.location === '') {
    errors.location = 'Location is required';
  }

  if (inputs.asset === '') {
    errors.asset = 'Asset is required';
  }


  return errors;
}

export const ChecklistItemForm = (inputs) => {
  let errors = {};

  if (inputs.checklist_item === '') {
    errors.checklist_item = 'question name is required';
  }

  if (inputs.detail === '') {
    errors.detail = 'Category is required';
  }

  if (inputs.question_category_id === '') {
    errors.question_category_id = 'Question Category is required';
  }

  if (inputs.response_type === '') {
    errors.response_type = 'Answer Type is required';
  }

  return errors;
}
export const AuditAnswerForm = (inputs) => {
  let errors = {};

  if (inputs.answer === '') {
    errors.answer = 'Answer is required';
  }

  if (inputs.score === '') {
    errors.score = 'score is required';
  }

  return errors;
}
export const VisitorForm = (inputs) => {
  let errors = {};

  if (inputs.visitorname === '') {
    errors.visitorname = 'Visitor Name is required';
  }
  if (inputs.organization === '') {
    errors.organization = 'Organization is required';
  }
  if (inputs.visitorcontact === '') {
    errors.visitorcontact = 'Visitor Contact is required';
  }

  if (inputs.host === '') {
    errors.host = 'Host is required';
  }
  return errors;
}
export const EnquiryForms = (inputs) => {
  let errors = {};

  // if (inputs.customername === '') {
  //   errors.customername = 'customer Name is required';
  // }
  //  if (inputs.state === '') {
  //   errors.state = 'State is required';
  // }
   if (!inputs.Projectid) {
    errors.Projectid = 'Project is required';
  }
  if (inputs.emailid === '') {
    errors.emailid = 'Email id is required';
  }
  if (inputs.mobileno === '') {
    errors.mobileno = 'Mobile number is required';
  }
  return errors;
}

export const EnquiryLeadForms = (inputs) => {
  let errors = {};

  if (inputs.customername === '') {
    errors.customername = 'customer Name is required';
  }

   if (!inputs.Projectid) {
    errors.Projectid = 'Project is required';
  }
  if (inputs.emailid === '') {
    errors.emailid = 'Email id is required';
  }
  if (inputs.mobileno === '') {
    errors.mobileno = 'Mobile number is required';
  }
  return errors;
}
export const FollowupForm = (inputs) => {
  let errors = {};

  // if (inputs.stage === '') {
  //   errors.stage = 'customer name Name is required';
  // }
  return errors;
}

export const AuditCommentForm = (inputs) => {
  let errors = {};

  if (inputs.comments === '') {
    errors.comments = 'Comment is required';
  }

  return errors;
}

export const TaskForm = (inputs) => {
  let errors = {};
  const isInteger = (value) => /^\d+(\.\d{1,2})?$/.test(value);
  if (inputs.title === '') {
    errors.title = 'Title is required';
  }
  return errors;
}

export const validatePicForm = (values) => {
  let errors = {};
  if (!values.image || values.image.length === 0) {
    errors.image = "Please upload an image";
  }
  return errors;
};

export const validateAuditForm = (values, data) => {
  let errors = {};

  if (data?.data?.checklist_summary === 1 && !values.summary?.trim()) {
    errors.summary = "Summary is required.";
  }

  if (data?.data?.auditor_sign === 1 && !values.auditor_sign?.length) {
    errors.auditor_sign = "Auditor signature is required.";
  }

  if (data?.data?.approver_sign === 1 && !values.approver_sign?.length) {
    errors.approver_sign = "Approver signature is required.";
  }

  if (!Object.keys(values.selectedAnswers || {}).length) {
    errors.answers = "Please answer at least one question.";
  }

  return errors;
};


export const HolidaysForm = (inputs) => {
  let errors = {};

  if (inputs.name === '') {
    errors.name = 'Occation is required';
  }
  if (inputs.date === '') {
    errors.date = 'Date is required';
  }


  return errors;
}

export const TasksForm = (inputs) => {
  let errors = {};

  if (inputs.task_title === '') {
    errors.task_title = 'Title is required';
  }
  if (inputs.duedate === '') {
    errors.duedate = 'Due date is required';
  }
  if (inputs.assigned_to === '') {
    errors.assigned_to = 'Assign to is required';
  }
  if (inputs.priority === '') {
    errors.priority = 'Priority is required';
  }
  if (inputs.status === '') {
    errors.status = 'Status is required';
  }

  return errors;
}

export const crmProjectForm = (inputs) => {
  let errors = {};

  if (inputs.project_title === '') {
    errors.project_title = 'Title is required';
  }


  return errors;
}

export const warehouseRack = (inputs) => {
  let errors = {}
  if (!inputs.rack_name) {
    errors.rack_name = "rack name is required";
  }
  if (!inputs.categories) {
    errors.categories = "categories are required";
  }

  return errors
}

export const WarehouseFormValidation = (inputs) => {
    if (!inputs) return {};
  let errors = {};

  // //  Common validations for all
  if (!inputs.warehouse_name) {
    errors.warehouse_name = "Warehouse Name is required";
  }
   if (!inputs.warehouse_code) {
    errors.warehouse_code = "Warehouse Code is required";
  }
  if (!inputs.warehouse_type) {
    errors.warehouse_type = "Warehouse Type is required";
  }
  if (!inputs.warehouse_type) {
    errors.warehouse_type = "Warehouse Type is required";
  }
  if (!inputs.total_storage_area) {
    errors.total_storage_area = "Total storage area is required";
  }
  if (!inputs.usable_storage_area) {
    errors.usable_storage_area = "Usable storage area is required";
  }
  if (!inputs.warehouse_poc) {
    errors.warehouse_poc = "Incharge Name is required";
  }
  if (!inputs.contact_number) {
    errors.contact_number = "Incharge Contact is required";
  }
  if (!inputs.state) {
    errors.state = "State is required";
  }
  if (!inputs.city) {
    errors.city = "City is required";
  }
  return errors;
};

export const CostsheetsForm = (inputs) => {
  let errors = {};

  if (!inputs.cost_sheet_name) {
    errors.cost_sheet_name = 'Enter Costsheet Name';
  }

  if (!inputs.project_id) {
    errors.project_id = 'Select Project';
  }
  
  if (!inputs.description) {
    errors.description = 'Enter Detail';
  }

  if (inputs.rstatus === '' || inputs.rstatus === null || inputs.rstatus === undefined) {
    errors.rstatus = 'Select Status';
  }


  return errors;
};

export const InfluencerSowForm = (inputs) => {
  let errors = {};

  if (!inputs.price) {
    errors.price = 'Enter Price';
  }

  return errors;
};

export const UTMForm = (inputs) => {
    let errors = {};

    if (!inputs.project_id) {
        errors.project_id = "Select Project";
    }

    if (!inputs.campaign_name?.trim()) {
        errors.campaign_name = "Enter Campaign Name";
    }

    if (!inputs.campaign_type) {
        errors.campaign_type = "Select Campaign Type";
    }

    if (!inputs.start_date || inputs.start_date.length === 0) {
        errors.start_date = "Select Start Date";
    }

    if (!inputs.end_date || inputs.end_date.length === 0) {
        errors.end_date = "Select End Date";
    }

    if (!inputs.channel) {
        errors.channel = "Select Channel";
    }

    if (!inputs.url?.trim()) {
        errors.url = "Enter Landing Page URL";
    } else if (
        !/^(https?:\/\/)([\w-]+\.)+[\w-]+(\/[\w-./?%&=]*)?$/.test(inputs.url)
    ) {
        errors.url = "Enter Valid URL";
    }

    if (!inputs.budget) {
        errors.budget = "Enter Budget";
    }

    if (!inputs.utm_source?.trim()) {
        errors.utm_source = "Enter UTM Source";
    }

    if (!inputs.utm_medium?.trim()) {
        errors.utm_medium = "Enter UTM Medium";
    }

    if (!inputs.utm_campaign?.trim()) {
        errors.utm_campaign = "Enter UTM Campaign";
    }

    return errors;
};

export const InfluencerForm = (inputs) => {
  let errors = {};

  if (!inputs.full_name) {
    errors.full_name = 'Enter Full Name';
  }

  if (!inputs.phone) {
    errors.phone = 'Enter Phone';
  }

  return errors;
};

export const CareerJobForm = (inputs) => {
  let errors = {};

  if (!inputs.job_title) {
    errors.job_title = 'Enter Job Title';
  }

  if (!inputs.location) {
    errors.location = 'Enter Location';
  }
  
  if (!inputs.employment_type) {
    errors.employment_type = 'Select Employment Type';
  }

  if (!inputs.salary_range) {
    errors.salary_range = 'Enter Salary Range';
  }

  if (!inputs.experience_level) {
    errors.experience_level = 'Enter Experience Level';
  }

  return errors;
};

export const ItemMasterForm = (inputs) => {
  let errors = {};

  // if (!inputs.attribute_name) {
  //   errors.attribute_name = 'Enter Attribute Name';
  // }

  // if (!inputs.attribute_description) {
  //   errors.attribute_description = 'Enter Attribute Description';
  // }


  return errors;
};
